import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_37cd7d2c";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_37cd7d2c" };
/** script content **/
require("./checkbox-modal.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex37cd7d2c%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fcheckbox-modal%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_37cd7d2c"],
    ctorType: "component",
    outputPath: "components/index37cd7d2c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-modal': getComponent(require("../modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")), 'cube-checkbox': getComponent(require("../checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex")), 'cube-checkbox-group': getComponent(require("../checkbox-group/index.mpx?isComponent&outputPath=components%2Findexc8b9c288%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
